import { useOverlayContext, useStoreActions, useStoreStatic } from "../../contexts";
import { useContacts } from "../../hooks/reactQuery/queries/useContacts";
import { selectors } from "../../store/state-selectors";
import { compact } from 'lodash-es';
export function useFetchAgreementStudioData(options) {
  const {
    fetchAgreements,
    fetchProposals,
    fetchLegalTerms,
    fetchQboClasses,
    fetchFinancialCentsUsers,
    fetchKarbonUsers
  } = useStoreActions();
  const {
    refresh: fetchContacts
  } = useContacts();
  const {
    disableLoader,
    disableLegalTerms,
    disableContacts,
    disableAgreements,
    disableProposals,
    disableQboClasses,
    disableFinancialCentsUsers,
    disableKarbonUsers
  } = options || {};
  const {
    startLoader,
    stopLoader
  } = useOverlayContext();
  const {
    getState
  } = useStoreStatic();
  return function fetchAgreementStudioData() {
    if (!disableLoader) {
      startLoader();
    }
    const requests = compact([!disableLegalTerms && fetchLegalTerms(), !disableContacts && fetchContacts(), !disableAgreements && fetchAgreements(), !disableProposals && fetchProposals(), !disableQboClasses && fetchQboClasses(), !disableFinancialCentsUsers && selectors.integration.showFinancialCentsIntegration(getState()) && fetchFinancialCentsUsers(), !disableKarbonUsers && selectors.integration.showKarbonIntegration(getState()) && fetchKarbonUsers()]);
    Promise.all(requests).catch(() => {}).finally(() => {
      if (!disableLoader) {
        stopLoader();
      }
    });
  };
}